webpackJsonp([1,2],{

/***/ 108:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 109:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 110:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 111:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 112:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 116:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(9)(
  /* script */
  __webpack_require__(57),
  /* template */
  __webpack_require__(125),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 117:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(111)

var Component = __webpack_require__(9)(
  /* script */
  __webpack_require__(59),
  /* template */
  __webpack_require__(127),
  /* scopeId */
  "data-v-6b50a898",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 118:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(109)

var Component = __webpack_require__(9)(
  /* script */
  __webpack_require__(60),
  /* template */
  __webpack_require__(123),
  /* scopeId */
  "data-v-41d3f06e",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 119:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(9)(
  /* script */
  __webpack_require__(61),
  /* template */
  __webpack_require__(128),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 120:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(9)(
  /* script */
  __webpack_require__(62),
  /* template */
  __webpack_require__(126),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 121:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(112)

var Component = __webpack_require__(9)(
  /* script */
  __webpack_require__(63),
  /* template */
  __webpack_require__(129),
  /* scopeId */
  "data-v-f06f484e",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 122:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wrapper-1"
  }, [_c('ul', {
    attrs: {
      "id": "nav"
    }
  }, [_c('router-link', {
    attrs: {
      "tag": "li",
      "to": "/color-spiral"
    }
  }, [_c('a', [_vm._v("1")])]), _vm._v(" "), _c('router-link', {
    attrs: {
      "tag": "li",
      "to": "/spiral"
    }
  }, [_c('a', [_vm._v("2")])]), _vm._v(" "), _c('router-link', {
    attrs: {
      "tag": "li",
      "to": "/canvas"
    }
  }, [_c('a', [_vm._v("3")])]), _vm._v(" "), _c('router-link', {
    attrs: {
      "tag": "li",
      "to": "/tunnel"
    }
  }, [_c('a', [_vm._v("4")])]), _vm._v(" "), _c('router-link', {
    attrs: {
      "tag": "li",
      "to": "/sunflower"
    }
  }, [_c('a', [_vm._v("5")])]), _vm._v(" "), _c('router-link', {
    attrs: {
      "tag": "li",
      "to": "/rainbow"
    }
  }, [_c('a', [_vm._v("6")])])], 1)])
},staticRenderFns: []}

/***/ }),

/***/ 123:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "scene"
  }, [_c('div', {
    staticClass: "boo",
    style: (_vm.booStyle)
  })])
},staticRenderFns: []}

/***/ }),

/***/ 124:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('a', {
    attrs: {
      "id": "fullscreen"
    },
    on: {
      "click": function($event) {
        _vm.enterFullscreen()
      }
    }
  }, [_vm._v("FULL SCREEN")]), _vm._v(" "), _c('nav-menu'), _vm._v(" "), _c('router-view')], 1)
},staticRenderFns: []}

/***/ }),

/***/ 125:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "canvas"
  }, [_c('canvas', {
    attrs: {
      "id": "canvas",
      "width": "600",
      "height": "600"
    }
  })])
}]}

/***/ }),

/***/ 126:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "canvas"
  }, [_c('canvas', {
    attrs: {
      "id": "canvas",
      "width": "500",
      "height": "500"
    }
  })])
}]}

/***/ }),

/***/ 127:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "star"
  }, _vm._l((_vm.countWaves), function(w) {
    return _c('div', {
      staticClass: "wave"
    }, _vm._l((_vm.countLines), function(l) {
      return _c('div', {
        staticClass: "line"
      }, [_c('div', {
        staticClass: "dot"
      }, [_vm._v(_vm._s(l.toString(2)))])])
    }))
  }))
},staticRenderFns: []}

/***/ }),

/***/ 128:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "hello"
  }, [_c('div', {
    staticClass: "boo",
    style: (_vm.booStyle)
  })])
},staticRenderFns: []}

/***/ }),

/***/ 129:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "scene",
    style: (_vm.sceneStyle),
    attrs: {
      "id": "tunnel-scene"
    }
  }, [_c('div', {
    staticClass: "wrapper",
    style: (_vm.wrapperStyle)
  }, [_c('ul', {
    staticClass: "tunnel"
  }, _vm._l((_vm.countDivs), function(n) {
    return _c('li', {
      staticClass: "ring",
      style: (_vm.ringStyle)
    })
  }))])])])
},staticRenderFns: []}

/***/ }),

/***/ 132:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(54);





__WEBPACK_IMPORTED_MODULE_0_vue__["default"].config.productionTip = false;

new __WEBPACK_IMPORTED_MODULE_0_vue__["default"]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_1__App___default.a }
});

/***/ }),

/***/ 52:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(108)

var Component = __webpack_require__(9)(
  /* script */
  __webpack_require__(58),
  /* template */
  __webpack_require__(122),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 54:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(130);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Spiral__ = __webpack_require__(119);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Spiral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_Spiral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_SacralCircle__ = __webpack_require__(118);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_SacralCircle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_SacralCircle__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Canvas__ = __webpack_require__(116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Canvas___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_Canvas__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Tunnel__ = __webpack_require__(121);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Tunnel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_Tunnel__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_SunflowerComponent__ = __webpack_require__(120);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_SunflowerComponent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_SunflowerComponent__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_RainbowComponent__ = __webpack_require__(117);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_RainbowComponent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_RainbowComponent__);









__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  routes: [{
    path: '/color-spiral',
    name: 'SacralCircle',
    component: __WEBPACK_IMPORTED_MODULE_3__components_SacralCircle___default.a
  }, {
    path: '/spiral',
    name: 'Spiral',
    component: __WEBPACK_IMPORTED_MODULE_2__components_Spiral___default.a
  }, {
    path: '/canvas',
    name: 'Canvas',
    component: __WEBPACK_IMPORTED_MODULE_4__components_Canvas___default.a
  }, {
    path: '/tunnel',
    name: 'Tunnel',
    component: __WEBPACK_IMPORTED_MODULE_5__components_Tunnel___default.a
  }, {
    path: '/sunflower',
    name: 'Sunflower',
    component: __WEBPACK_IMPORTED_MODULE_6__components_SunflowerComponent___default.a
  }, {
    path: '/rainbow',
    name: 'Rainbow',
    component: __WEBPACK_IMPORTED_MODULE_7__components_RainbowComponent___default.a
  }]
});

/***/ }),

/***/ 55:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(110)

var Component = __webpack_require__(9)(
  /* script */
  __webpack_require__(56),
  /* template */
  __webpack_require__(124),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 56:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_property_decorator__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_property_decorator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vue_property_decorator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_NavMenu__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_NavMenu___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_NavMenu__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return App; });







var _dec, _class, _desc, _value, _class2;

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}





__WEBPACK_IMPORTED_MODULE_6_vue__["default"].component('nav-menu', __webpack_require__(52));

var App = (_dec = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_vue_property_decorator__["Watch"])('$route'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_vue_property_decorator__["Component"])(_class = (_class2 = function (_Vue) {
  __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default()(App, _Vue);

  function App() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, App);

    return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(this, (App.__proto__ || __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default()(App)).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(App, [{
    key: 'enterFullscreen',
    value: function enterFullscreen() {
      var el = document.getElementById('fullscreen').nextSibling.nextSibling.nextSibling.nextSibling;
      console.log(el);
      el.webkitRequestFullScreen ? el.webkitRequestFullScreen(Element.ALLOW_KEYBOARD_INPUT) : el.mozRequestFullScreen();
    }
  }, {
    key: 'onRouteChanged',
    value: function onRouteChanged(to, from) {
      var element = document.querySelector('.main.a');
      element && element.remove();
    }
  }]);

  return App;
}(__WEBPACK_IMPORTED_MODULE_6_vue__["default"]), (_applyDecoratedDescriptor(_class2.prototype, 'onRouteChanged', [_dec], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class2.prototype, 'onRouteChanged'), _class2.prototype)), _class2)) || _class);


/***/ }),

/***/ 57:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_property_decorator__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_property_decorator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue_property_decorator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_dat_gui__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_dat_gui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_dat_gui__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return Canvas; });






var _class;





var Canvas = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_vue_property_decorator__["Component"])(_class = function (_Vue) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(Canvas, _Vue);

  function Canvas() {
    var _ref;

    var _temp, _this, _ret;

    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, Canvas);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (_ref = Canvas.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(Canvas)).call.apply(_ref, [this].concat(args))), _this), _this.datgui = new __WEBPACK_IMPORTED_MODULE_7_dat_gui___default.a.GUI(), _this.length = 200, _this.divisions = 50, _this.speed = 120 * 1000, _this.colorSpeed = 60, _temp), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(_this, _ret);
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(Canvas, [{
    key: 'drawFrame',
    value: function drawFrame(timestamp) {
      var prev = {};
      var r = Math.floor(timestamp / this.colorSpeed);
      if (timestamp - this.target.timestamp > this.speed) {
        this.target.timestamp = 0;
        var temp = this.target.origin;
        this.target.origin = this.target.destination;
        this.target.destination = temp;
      }
      if (this.target.timestamp === 0) {
        this.target.timestamp = timestamp;
      }
      var factor = this.easeInOutSine(timestamp - this.target.timestamp, this.target.origin, this.target.destination - this.target.origin, this.speed);
      this.ctx.fillRect(0, 0, this.width, this.height);
      for (var i = 0; i < this.length; i++) {
        var point = {};
        point.r = this.linearEase(i, 1, this.radius - 1, this.length);
        point.t = (360 / this.divisions * i + factor * i) * Math.PI / 180;
        point.x = point.r * Math.cos(point.t) + this.center.x;
        point.y = point.r * Math.sin(point.t) + this.center.y;
        this.ctx.beginPath();
        var c = this.rainbow[(r + i) % this.rLength];
        this.ctx.strokeStyle = "rgba(" + c.r + ", " + c.g + ", " + c.b + ", 0.5)";
        this.ctx.moveTo(prev.x, prev.y);
        this.ctx.lineTo(point.x, point.y);
        this.ctx.stroke();
        prev.x = point.x;
        prev.y = point.y;
      }
      window.requestAnimationFrame(this.drawFrame);
    }
  }, {
    key: 'linearEase',
    value: function linearEase(ci, sv, civ, ti) {
      return civ * ci / ti + sv;
    }
  }, {
    key: 'easeInOutSine',
    value: function easeInOutSine(ci, sv, civ, ti) {
      return civ / 2 * (1 - Math.cos(Math.PI * ci / ti)) + sv;
    }
  }, {
    key: 'makeColorGradient',
    value: function makeColorGradient(len) {
      var f1 = 2 * Math.PI / len * 1;
      var f2 = 2 * Math.PI / len * 1;
      var f3 = 2 * Math.PI / len * 1;
      var o1 = 0;
      var o2 = 2 * Math.PI / 3;
      var o3 = 4 * Math.PI / 3;
      var w = 127;
      var c = 128;
      var a = [];
      for (var i = 0; i < len; i++) {
        var r = Math.round(Math.sin(f1 * i + o1) * w + c);
        var g = Math.round(Math.sin(f2 * i + o2) * w + c);
        var b = Math.round(Math.sin(f3 * i + o3) * w + c);
        a.push({ r: r, g: g, b: b });
      }
      return a;
    }
  }, {
    key: 'mounted',
    value: function mounted() {
      this.canvas = document.getElementById('canvas');
      this.ctx = this.canvas.getContext("2d");
      this.ctx.fillStyle = "#000";
      this.ctx.strokeStyle = "rgba(255, 255, 255, 0.2)";
      this.ctx.lineWidth = 2;

      this.width = this.canvas.width;
      this.height = this.canvas.height;
      this.diameter = this.width - this.width * 0.1;
      this.radius = this.diameter / 2;
      this.center = { x: this.width / 2, y: this.height / 2 };
      this.rainbow = this.makeColorGradient(this.length);
      this.rLength = this.rainbow.length;

      this.target = {
        origin: -180,
        destination: 180,
        timestamp: 0
      };
      window.requestAnimationFrame(this.drawFrame);

      this.datgui.add(this, 'length', 200, 500, 10);
      this.datgui.add(this, 'divisions', 10, 50);
      this.datgui.add(this, 'speed', 120, 112000, 100);
      this.datgui.add(this, 'colorSpeed', 5, 100, 1);
    }
  }]);

  return Canvas;
}(__WEBPACK_IMPORTED_MODULE_5_vue__["default"])) || _class;



/***/ }),

/***/ 58:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_property_decorator__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_property_decorator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_property_decorator__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return Navmenu; });





var _class;




var Navmenu = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vue_property_decorator__["Component"])(_class = function (_Vue) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(Navmenu, _Vue);

  function Navmenu() {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, Navmenu);

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, (Navmenu.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(Navmenu)).apply(this, arguments));
  }

  return Navmenu;
}(__WEBPACK_IMPORTED_MODULE_4_vue__["default"])) || _class;



/***/ }),

/***/ 59:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_property_decorator__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_property_decorator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue_property_decorator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_dat_gui__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_dat_gui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_dat_gui__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return Tunnel; });






var _class;





var Tunnel = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_vue_property_decorator__["Component"])(_class = function (_Vue) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(Tunnel, _Vue);

  function Tunnel() {
    var _ref;

    var _temp, _this, _ret;

    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, Tunnel);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (_ref = Tunnel.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(Tunnel)).call.apply(_ref, [this].concat(args))), _this), _this.datgui = new __WEBPACK_IMPORTED_MODULE_7_dat_gui___default.a.GUI(), _this.countWaves = 4, _this.countLines = 50, _temp), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(_this, _ret);
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(Tunnel, [{
    key: 'mounted',
    value: function mounted() {}
  }]);

  return Tunnel;
}(__WEBPACK_IMPORTED_MODULE_5_vue__["default"])) || _class;



/***/ }),

/***/ 60:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_property_decorator__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_property_decorator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue_property_decorator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_dat_gui__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_dat_gui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_dat_gui__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return SacralCircle; });






var _class;





var SacralCircle = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_vue_property_decorator__["Component"])(_class = function (_Vue) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(SacralCircle, _Vue);

  function SacralCircle() {
    var _ref;

    var _temp, _this, _ret;

    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, SacralCircle);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (_ref = SacralCircle.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(SacralCircle)).call.apply(_ref, [this].concat(args))), _this), _this.datgui = new __WEBPACK_IMPORTED_MODULE_7_dat_gui___default.a.GUI(), _this.currentFrame = 0, _this.fudge = 0.87, _this.nbrCircles = 150, _this.deviation = 5 / 8.0, _this.lgRad = 13, _temp), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(_this, _ret);
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(SacralCircle, [{
    key: 'drawFrame',
    value: function drawFrame() {
      this.currentFrame++;
      window.requestAnimationFrame(this.drawFrame);
    }
  }, {
    key: 'mounted',
    value: function mounted() {
      window.requestAnimationFrame(this.drawFrame);

      this.datgui.add(this, 'nbrCircles', 100, 1000, 100);
      this.datgui.add(this, 'fudge', 0, 1, 0.1);
      this.datgui.add(this, 'deviation', -1, 1, 0.1);
      this.datgui.add(this, 'lgRad', 5, 30, 1);
    }
  }, {
    key: 'booStyle',
    get: function get() {
      var boxShadowInitial = '',
          phi = (Math.sqrt(5) + 1) / 2 + 3,
          goldenAngle = phi * (33 + Math.PI),
          lgArea = Math.pow(this.lgRad, 2) * Math.PI,
          meanArea = lgArea / this.nbrCircles,
          minArea = meanArea * (1 - this.deviation),
          maxArea = meanArea * (1 + this.deviation),
          cumArea = 0,
          hueIncrement = this.currentFrame * .0002 + .1,
          angleOffset = this.currentFrame * .005;

      for (var i = 1; i <= this.nbrCircles; ++i) {

        var angle = i * goldenAngle + angleOffset,
            ratio = i / this.nbrCircles,
            smallArea = minArea + ratio * (maxArea - minArea),
            smallRadius = Math.sqrt(smallArea / Math.PI);

        cumArea += smallArea;

        var spiral_rad = Math.sqrt(cumArea / Math.PI),
            x = Math.cos(angle) * spiral_rad,
            y = Math.sin(angle) * spiral_rad,
            hue = hueIncrement * i;

        hue -= Math.floor(hue);
        hue *= 360;

        if (boxShadowInitial.length > 0) {
          boxShadowInitial += ', ';
        }
        boxShadowInitial += x + 'em ' + y + 'em 0 ' + smallRadius * this.fudge + 'em hsl(' + hue + ', 100%, 50%)';
      }

      return {
        'box-shadow': boxShadowInitial
      };
    }
  }]);

  return SacralCircle;
}(__WEBPACK_IMPORTED_MODULE_5_vue__["default"])) || _class;



/***/ }),

/***/ 61:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_property_decorator__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_property_decorator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue_property_decorator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_dat_gui__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_dat_gui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_dat_gui__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return Spiral; });






var _class;





var Spiral = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_vue_property_decorator__["Component"])(_class = function (_Vue) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(Spiral, _Vue);

  function Spiral() {
    var _ref;

    var _temp, _this, _ret;

    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, Spiral);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (_ref = Spiral.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(Spiral)).call.apply(_ref, [this].concat(args))), _this), _this.datgui = new __WEBPACK_IMPORTED_MODULE_7_dat_gui___default.a.GUI(), _this.dotsCount = 20, _this.colorsCount = 7, _this.colorsRepeat = 3, _this.cutOff = .25, _this.diam = 0.125, _this.scaleFactor = 15, _this.cutOffFactor = 4, _this.multiply = 2, _this.cutOffShift = 1, _temp), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(_this, _ret);
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(Spiral, [{
    key: 'mounted',
    value: function mounted() {
      this.datgui.add(this, 'dotsCount', 10, 100);
      this.datgui.add(this, 'colorsCount', 1, 15);
      this.datgui.add(this, 'colorsRepeat', 1, 10);
      this.datgui.add(this, 'cutOff', 0.1, 1, 0.1);
      this.datgui.add(this, 'diam', 0.1, 1, 0.1);
      this.datgui.add(this, 'scaleFactor', 1, 50);
      this.datgui.add(this, 'cutOffShift', 1, 10);
    }
  }, {
    key: 'booStyle',
    get: function get() {

      var n = this.colorsCount,
          m = this.colorsRepeat,
          p = this.dotsCount,
          d = this.diam,
          cutoff = this.cutOff,
          boxShadowInitial = '',
          boxShadowTo = '',
          multiply = this.multiply;

      for (var i = 0, totalColors = n * m; i <= totalColors; i++) {
        var betaAngle = i * multiply * Math.PI / totalColors,
            colorHue = i * 360 / n,
            x = 0,
            y = 0,
            xFrom = 0,
            yFrom = 0,
            xTo = 0,
            yto = 0;

        for (var j = 1; j <= p; j++) {
          var gammaAngle = j * multiply * Math.PI / p,
              s = this.scaleFactor * (cutoff * p - j) * (j - (this.cutOffShift + cutoff / this.cutOffFactor) * p) / Math.pow((0.5 + cutoff) * p, multiply);

          if (j < cutoff * p) {
            s = 0;
          }

          x = x + 1.65 * (s + 1) * d;
          y = x * Math.sin(gammaAngle) / 5;

          xFrom = x * Math.cos(betaAngle) - y * Math.sin(betaAngle);
          yFrom = x * Math.sin(betaAngle) + y * Math.cos(betaAngle);

          if (boxShadowInitial.length > 0) {
            boxShadowInitial += ', ';
          }
          boxShadowInitial += xFrom + 'em ' + yFrom + 'em 0 ' + s * d + 'em hsl(' + colorHue + ', 100%, 50%)';

          xTo = x * Math.cos(betaAngle + gammaAngle);
          yto = x * Math.sin(betaAngle + gammaAngle);
          if (boxShadowTo.length > 0) {
            boxShadowTo += ', ';
          }
          boxShadowTo += xTo + 'em ' + yto + 'em 0 ' + d / multiply + 'em hsl(' + colorHue + ', 100%, 50%)';
        }
      }

      var style = document.createElement('style');
      style.type = 'text/css';
      style.innerHTML = '\n      @keyframes flexibleSpiral {\n        to {\n          box-shadow: ' + boxShadowTo + '\n        }\n      }';
      document.getElementsByTagName('head')[0].appendChild(style);

      return {
        'margin': -d / 2 + 'em',
        'width': d + 'em',
        'height': d + 'em',
        'box-shadow': boxShadowInitial,
        'position': 'absolute',
        'top': '50%',
        'left': '50%',
        'border-radius': '50%',
        'background-color': 'black',
        'animation': 'flexibleSpiral 2s ease-in-out infinite alternate'
      };
    }
  }]);

  return Spiral;
}(__WEBPACK_IMPORTED_MODULE_5_vue__["default"])) || _class;



/***/ }),

/***/ 62:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_property_decorator__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_property_decorator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vue_property_decorator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Sunflower__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_dat_gui__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_dat_gui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_dat_gui__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return SunflowerComponent; });







var _dec, _dec2, _dec3, _class, _desc, _value, _class2;

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}






var SunflowerComponent = (_dec = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_vue_property_decorator__["Watch"])('seeds'), _dec2 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_vue_property_decorator__["Watch"])('rotateOn'), _dec3 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_vue_property_decorator__["Watch"])('radius'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_vue_property_decorator__["Component"])(_class = (_class2 = function (_Vue) {
  __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default()(SunflowerComponent, _Vue);

  function SunflowerComponent() {
    var _ref;

    var _temp, _this, _ret;

    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, SunflowerComponent);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(this, (_ref = SunflowerComponent.__proto__ || __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default()(SunflowerComponent)).call.apply(_ref, [this].concat(args))), _this), _this.datgui = new __WEBPACK_IMPORTED_MODULE_9_dat_gui___default.a.GUI(), _this.seeds = 2000, _this.rotateOn = false, _this.radius = 2, _temp), __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(_this, _ret);
  }

  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(SunflowerComponent, [{
    key: 'mounted',
    value: function mounted() {
      this.sunflower = new __WEBPACK_IMPORTED_MODULE_8__Sunflower__["a" /* default */]('canvas');
      this.sunflower.animate();

      this.datgui.add(this, 'seeds', 70, 3000, 10);
      this.datgui.add(this, 'rotateOn');
      this.datgui.add(this, 'radius', 2, 100, 1);
    }
  }, {
    key: 'onSeedsChanged',
    value: function onSeedsChanged() {
      this.sunflower.seeds = this.seeds;
    }
  }, {
    key: 'onRotateChanged',
    value: function onRotateChanged() {
      this.sunflower.rotateOn = this.rotateOn;
    }
  }, {
    key: 'onRadiusChanged',
    value: function onRadiusChanged() {
      this.sunflower.radius = this.radius;
    }
  }]);

  return SunflowerComponent;
}(__WEBPACK_IMPORTED_MODULE_6_vue__["default"]), (_applyDecoratedDescriptor(_class2.prototype, 'onSeedsChanged', [_dec], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class2.prototype, 'onSeedsChanged'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'onRotateChanged', [_dec2], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class2.prototype, 'onRotateChanged'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'onRadiusChanged', [_dec3], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class2.prototype, 'onRadiusChanged'), _class2.prototype)), _class2)) || _class);


/***/ }),

/***/ 63:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_property_decorator__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_property_decorator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue_property_decorator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_dat_gui__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_dat_gui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_dat_gui__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return Tunnel; });






var _class;





var Tunnel = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_vue_property_decorator__["Component"])(_class = function (_Vue) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(Tunnel, _Vue);

  function Tunnel() {
    var _ref;

    var _temp, _this, _ret;

    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, Tunnel);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (_ref = Tunnel.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(Tunnel)).call.apply(_ref, [this].concat(args))), _this), _this.datgui = new __WEBPACK_IMPORTED_MODULE_7_dat_gui___default.a.GUI(), _this.countDivs = 72, _this.transformOrigin = 25, _this.perspective = 20, _this.wrapperTransformZ = 3, _this.wrapperTransformY = -2, _this.wrapperTransformX = 10, _temp), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(_this, _ret);
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(Tunnel, [{
    key: 'mounted',
    value: function mounted() {
      this.datgui.add(this, 'transformOrigin', 20, 50);
      this.datgui.add(this, 'perspective', 15, 50);
      this.datgui.add(this, 'wrapperTransformZ', -40, 20).name('Z translate');
      this.datgui.add(this, 'wrapperTransformY', -20, 20).name('Y translate');
      this.datgui.add(this, 'wrapperTransformX', -100, 100).name('X translate');
    }
  }, {
    key: 'ringStyle',
    get: function get() {
      return {
        'transform-origin': this.transformOrigin + '% ' + this.transformOrigin + '%'
      };
    }
  }, {
    key: 'sceneStyle',
    get: function get() {
      return {
        'perspective': this.perspective + 'em'
      };
    }
  }, {
    key: 'wrapperStyle',
    get: function get() {
      var zTrans = 'translateZ(' + this.wrapperTransformZ + 'em) ';
      var yTrans = 'translateY(' + this.wrapperTransformY + 'em) ';
      var xTrans = 'translateX(' + this.wrapperTransformX + '%)';
      return {
        'transform': zTrans + yTrans + xTrans
      };
    }
  }]);

  return Tunnel;
}(__WEBPACK_IMPORTED_MODULE_5_vue__["default"])) || _class;



/***/ }),

/***/ 64:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Sunflower; });



var Sunflower = function () {
  function Sunflower(id) {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, Sunflower);

    var canvas = document.getElementById(id);
    this.ctx = canvas.getContext('2d');

    this.seeds = 2000;
    this.rotateOn = false;
    this.radius = 2;
    this.SCALE_FACTOR = 4;
    this.MAX_D = canvas.width;
    this.xc = this.MAX_D / 2;
    this.yc = this.MAX_D / 2;
    this.TAU = Math.PI * 2;
    this.PHI = (Math.sqrt(5) + 1) / 2;

    window.requestAnimFrame = function () {
      return window.requestAnimationFrame || window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame || window.oRequestAnimationFrame || window.msRequestAnimationFrame || function (callback, element) {
        window.setTimeout(callback, 1000 / 60);
      };
    }();
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(Sunflower, [{
    key: 'animate',
    value: function animate() {
      window.requestAnimFrame(this.animate.bind(this));
      if (this.rotate === 360) {
        this.rotate = 0;
      }
      this.drawFrame();
    }
  }, {
    key: 'drawFrame',
    value: function drawFrame() {
      this.ctx.clearRect(0, 0, this.MAX_D, this.MAX_D);
      this.ctx.translate(this.xc, this.yc);
      if (this.rotateOn) {
        this.ctx.rotate(Math.PI / 180);
      }
      this.ctx.translate(-this.xc, -this.yc);
      for (var i = 0; i < this.seeds; i++) {
        var theta = i * this.TAU / this.PHI,
            r = Math.sqrt(i) * this.SCALE_FACTOR,
            x = this.xc + r * Math.cos(theta),
            y = this.yc - r * Math.sin(theta);
        this.drawSeed(x, y, theta);
      }
    }
  }, {
    key: 'drawSeed',
    value: function drawSeed(x, y, theta) {
      this.ctx.beginPath();
      this.ctx.lineWidth = 0;
      this.ctx.fillStyle = 'hsl(' + Math.cos(theta) * Math.sin(theta) * 10000 + ', 100%, 50%)';

      var radius = eval(this.radius);
      radius = radius < 0 ? radius * -1 : radius;
      this.ctx.arc(x, y, radius, 0, this.TAU, false);
      this.ctx.fill();
      this.ctx.closePath();
      this.ctx.stroke();
    }
  }]);

  return Sunflower;
}();



/***/ })

},[132]);


// WEBPACK FOOTER //
// static/js/app.41d194b6ee4df9a2591c.js